import { browserHistory } from 'react-router';
import request from 'superagent';
import { startLoad, finishLoad } from './loader';
import { receiveTether, receiveAuth } from './auth';
import { addError, addStatus } from './utils';

function receiveCompleteTasks(tasks) {
  return {
    type: 'RECEIVE_COMPLETE_TASKS',
    tasks,
  };
}

function receiveCurrentCourses(current) {
  return {
    type: 'RECEIVE_CURRENT_COURSES',
    current,
  };
}

export function receiveSubscribition(subs) {
  return {
    type: 'RECEIVE_SUBSCRIBITION',
    subs,
  };
}

function receivePayments(payments, plans, lessons) {
  return {
    type: 'RECEIVE_PAYMENTS',
    payments,
    plans,
    lessons,
  };
}

function receiveMarketing(marketing) {
  return {
    type: 'RECEIVE_MARKETING',
    marketing,
  };
}

export function getCompleteTasks() {
  return dispatch => {
    request.post('/user/completetasks').end((err, res) => {
      if (err) {
        dispatch(receiveCompleteTasks([]));
      }
      dispatch(receiveCompleteTasks(res.body));
    });
  };
}

export function getCurrentCourses() {
  return dispatch => {
    dispatch(startLoad('getCurrentCourses', 'Получение текущих курсов'));
    request.post('/user/currentcourses').end((err, res) => {
      dispatch(finishLoad('getCurrentCourses'));
      if (err) {
        dispatch(receiveCurrentCourses({}));
      } else {
        dispatch(receiveCurrentCourses(res.body));
      }
    });
  };
}

export function getNickname() {
  return dispatch => {
    request.post('/user/nickname').end((err, res) => {
      if (err) {
        dispatch(receiveTether({ result: false }));
      } else {
        dispatch(receiveTether(res.body));
      }
    });
  };
}

export function getTrial(redirect) {
  return dispatch => {
    request.post('/user/getTrial').end((err, res) => {
      if (err) {
        dispatch(addError(err));
      } else {
        dispatch(receiveSubscribition(res.body));
        if (!redirect) {
          browserHistory.push('/i');
        } else {
          browserHistory.push(redirect);
        }

        dispatch(addStatus('Ваша пробная подписка была успешно активирована'));
      }
    });
  };
}

export function getPayments() {
  return dispatch => {
    request.get('/user/payments').end((err, res) => {
      if (err) {
        dispatch(addError(err));
      } else {
        dispatch(
          receivePayments(res.body.payments, res.body.plans, res.body.lessons)
        );
      }
    });
  };
}

export function cancelRecurrent() {
  return dispatch => {
    request.post('/payment/cancel').end((err, res) => {
      if (err) {
        dispatch(addError(err));
      } else {
        dispatch(receiveAuth(res.body));
        dispatch(addStatus('Вы успешно отметили автопродление подписки'));
      }
    });
  };
}

export function updateMarketing(marketing) {
  return dispatch => {
    request
      .post('/user/updateMarketing')
      .send({ marketing })
      .end((err, res) => {
        if (!err) {
          dispatch(receiveMarketing(res.body));
        }
      });
  };
}

export function updateCache(updatedCache) {
  return () => {
    request
      .post('/user/updateCache')
      .send({ updatedCache })
      .end(() => {});
  };
}
